import _ from 'lodash';

export default {
    mounted() {
        const resizeHandler = _.debounce(() => {
            this.$bus.$emit('window-resize');
        }, 300);
        window.addEventListener('resize', resizeHandler);
    },
};
